import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';
import { media } from 'components/responsive';
import partnersIllustration from '../../../../assets/Health/partners_illustration.png';
const messages = defineMessages({
    title: 'Stronger Together: Our Health Partners',
    subtitle: 'We join forces with health leaders, insurers, and charities to turn movement into medicine. We are on a mission to reduce the health burden of chronic lifestyle conditions by incentivising movement to achieve behavioural change.',
    item1: 'From the NHS to private health, leading insurers, pharma, charities, and sports brands — our partners power the movement. <strong>Together, we’re transforming prevention, boosting engagement, and making every step count.</strong>',
    item2: 'Our <strong>multi-award-winning Prevention Decathlon turns movement into a lifesaving habit by creating long lasting behavioural change.</strong> We design custom, time-bound programs that help those at risk of chronic conditions, such as diabetes, cardiovascular disease, and obesity - that help participants understand their condition risks, motivation to move more, stay engaged, and take control of their health — one step at a time.',
    item3: 'Sweatcoin removes barriers — no expensive wearables, no subscriptions — just movement that pays off. We collaborate with health partners to create tailored activity programs, featuring personalized and motivational health content, with interactive leaderboards and challenges, enabling participants to earn exclusive health partner rewards.',
});
const Partners = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Layout, { id: "partners" },
            React.createElement(HeadSection, null,
                React.createElement("div", null,
                    React.createElement(Title, null,
                        React.createElement(FormattedMessage, { ...messages.title })),
                    React.createElement(FormattedMessage, { ...messages.subtitle })),
                React.createElement(Illustration, { src: partnersIllustration, alt: "partners illustration" })),
            React.createElement(Section, null,
                React.createElement(Item, null,
                    React.createElement(FormattedMessage, { ...messages.item1 })),
                React.createElement(Item, null,
                    React.createElement(FormattedMessage, { ...messages.item2 })),
                React.createElement(Item, null,
                    React.createElement(FormattedMessage, { ...messages.item3 }))))));
};
const Layout = styled.div `
  background-size: cover;
  border-radius: 50px;
  padding: 40px 16px;
  margin-top: 140px;
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.desktop `
    padding: 50px 90px 0;
  `};
`;
const Illustration = styled.img `
  display: block;
  width: 100%;
  object-fit: contain;
  object-position: center;

  ${media.desktop `
    width: 40%;
    `}
`;
const Title = styled.h2 `
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 50px;
  color: #5e2394;
  margin-bottom: 30px;

  ${media.desktop `
    max-width: 600px;
    margin-bottom: 70px;
  `};

  strong {
    font-weight: 800;
  }
`;
const Item = styled.p `
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
  font-size: 16px;
  margin-bottom: 60px;
  ${media.desktop `
    flex: 1;
  `}

  strong {
    font-weight: 700;
  }
`;
const HeadSection = styled.div `
  display: flex;
  flex-direction: column-reverse;
  max-width: 100%;
  gap: 60px;

  ${media.desktop `
    flex-direction: row;
  `}
`;
const Section = styled.div `
  margin-top: 78px;
  display: flex;
  flex-direction: column;
  gap: 90px;
  ${media.desktop `
    flex-direction: row;
  `}
`;
export default Partners;
